'use client';

import { useEffect, useRef } from 'react';

const TRUTH_URL_REGEX = /^https:\/\/truthsocial\.com\/@(?<username>[\w-]+)\/posts\/(?<postId>\d+)\/?$/;

type TruthEmbedProps = {
  url: string;
  className?: string;
};

export const TruthEmbed = ({ url, className }: TruthEmbedProps) => {

  const loaderRef = useRef<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const match = TRUTH_URL_REGEX.exec(url);
  if (!match?.groups) {
    console.error('Invalid Truth Social URL:', url);
    return;
  }
  const { username, postId } = match.groups;

  useEffect(() => {
    if (loaderRef.current) return;
    const script = document.createElement('script');
    script.src = 'https://truthsocial.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
    loaderRef.current = true;
  }, []);

  useEffect(() => {
    const iframe = document.createElement('iframe');
    iframe.src = `https://truthsocial.com/@${username}/${postId}/embed`;
    iframe.className = ['truthsocial-embed', className].filter(Boolean).join(' ');
    iframe.width = '600';

    Object.assign(iframe.style, {
      maxWidth: '100%',
      border: '0',
      overflow: 'hidden',
    });
    iframe.allowFullscreen = true;

    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = '';
    container.appendChild(iframe);

  }, [url, className]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ margin: '1.5rem auto', textAlign: 'center' }}
    />
  )
};

export default TruthEmbed;